import type { CanvasRetrieve, MiniUser } from '@openapi'

export enum CoreFolderEntityType {
  Block = 'canvas_block',
  Canvas = 'canvas',
  File = 'file',
  Section = 'canvas_section',
  Template = 'canvas_template',
}

export type CoreFolderContentsRetrieve = {
  id: string
  name: string
  folders: CoreFolderRetrieve[]
  contents: CanvasRetrieve[]
  path?: any[]
}

export interface CoreFolderRetrieve {
  id: string
  name: string
  path: string
  parent_id: string | null
  created_at: string
  modified_at: string
  instance_id: string
  metadata: Record<string, any>
  access_type: 'private' | 'public'
  breadcrumbs: Array<{ id: string | null; name: string }>
  files_count: number
  folders_count: number
  created_by: MiniUser
  modified_by: MiniUser | null
  owned_by: MiniUser
}
